module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Billionaire's Bride of Innocence")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "contents"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("CONTENTS")]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry3"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_fm04#fm04"
    }
  }, [_vm._v("PROLOGUE")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry4"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch01#ch01"
    }
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry5"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWO")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry6"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry7"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry8"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry9"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])])])]), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "contentsEntry21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/billionairesbrideofinnocencethe_ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c57f05c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billionairesbrideofinnocencethe_contents.vue
// module id = 69
// module chunks = 0